export enum DefaultComponentType {
  INPUT = 'input',
  SELECT = 'select',
}
export interface IFieldPreset {
  fieldName: string;
  alias: string;
  defaultValueHint: string;
  defaultValue?: string;
  required: boolean;
  defaultComponentType: {
    type: 'input' | 'select';
    options?: { label: string; value: string }[];
  };
}

export enum FieldName{
  CREATOR = 'creator',
  PROCESSOR = 'processor',
  VERSION = 'app_version',
  PRIORITY = 'priority',
}

export const FIELDS_PRESET: IFieldPreset[] = [
  {
    fieldName: FieldName.CREATOR,
    alias: '创建人',
    defaultValue: '${userName}',
    required: true,
    defaultValueHint: '默认传入系统当前用户',
    defaultComponentType: {
      type: DefaultComponentType.INPUT,
    },
  },
  {
    fieldName: FieldName.PROCESSOR,
    alias: '处理人',
    defaultValue: undefined,
    required: true,
    defaultValueHint: '请输入',
    defaultComponentType: {
      type: DefaultComponentType.INPUT,
    },
  },
  {
    fieldName: FieldName.VERSION,
    alias: '发现版本',
    defaultValue: '${version}',
    required: true,
    defaultValueHint: '默认传入当前版本',
    defaultComponentType: {
      type: DefaultComponentType.INPUT,
    },
  },
  {
    fieldName: FieldName.PRIORITY,
    alias: '优先级',
    defaultValue: undefined,
    required: true,
    defaultValueHint: '请输入',
    defaultComponentType: {
      type: DefaultComponentType.SELECT,
      options: [
        { label: 'High', value: 'High' },
        { label: 'Medium', value: 'Medium' },
        { label: 'Low', value: 'Low' },
      ],
    },
  },
];
